import { render, staticRenderFns } from "./StockInventoryToolField.vue?vue&type=template&id=57b5c9c4&scoped=true&"
import script from "./StockInventoryToolField.vue?vue&type=script&lang=js&"
export * from "./StockInventoryToolField.vue?vue&type=script&lang=js&"
import style0 from "./StockInventoryToolField.vue?vue&type=style&index=0&id=57b5c9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b5c9c4",
  null
  
)

export default component.exports
import {QChip,QAvatar,QList,QItem,QItemSection,QItemLabel,QIcon} from 'quasar'
component.options.components = Object.assign({QChip,QAvatar,QList,QItem,QItemSection,QItemLabel,QIcon}, component.options.components || {})
